import { useEffect, useState } from "react";

export const useIsRootstockConnected = () => {
  const [isConnected, setIsConnected] = useState(false);

  const checkChainId = async () => {
    try {
      const chainId = await window.ethereum?.request({ method: "eth_chainId" });
      setIsConnected(chainId === "0x1e");
    } catch {
      setIsConnected(false);
    }
  };

  useEffect(() => {
    checkChainId();
    window.ethereum?.on("chainChanged", checkChainId);
    return () => window.ethereum?.removeListener("chainChanged", checkChainId);
  }, []);

  return isConnected;
};
